import { FC } from 'react';
import { SiteTabProps } from './SiteTabProps';
import { ESTABLISHMENT_TYPE } from '../ProjectTypeSelect/utils';
import NewUnitSiteForm from './NewUnitSiteForm';
import ImproveSiteForm from './ImproveSiteForm';
import RelocationSiteForm from './RelocationSiteForm';
import FormatChangeSiteForm from './FormatChangeSiteForm';
import CloseSiteForm from './CloseSiteForm';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTypedSelector } from '../../store';
import { selectCurrencyArray } from '../../store/currency/selectors';
import { returnCurrencySymbol } from '../../utils/utils';
import countryToCurrency from 'country-to-currency/index';
import { getCurrencyRate } from '../ProjectTabFinancials/utils';

const SiteTab: FC<SiteTabProps> = ({
  tabType,
  countries,
  BuList,
  onCountryChange,
  onBUChange,
  isEdit,
}) => {
  const { control } = useFormContext();
  const transactionType = useWatch({ name: 'transactionType', control });
  const isLeasedFromAnotherIngkaCompany = useWatch({
    name: 'isLeasedFromAnotherIngkaCompany',
    control,
  });
  const currencies = useTypedSelector(selectCurrencyArray);
  const countryCode = useWatch({ name: 'countryCode', control });
  const currency = returnCurrencySymbol(
    countryToCurrency[countryCode] || 'SEK',
  );
  const currencyRate = getCurrencyRate(countryCode, currencies);

  switch (tabType) {
    case ESTABLISHMENT_TYPE.NEW_UNIT:
      return (
        <NewUnitSiteForm
          countries={countries}
          BuList={BuList}
          onCountryChange={onCountryChange}
          onBUChange={onBUChange}
          transactionType={transactionType}
          isLeasedFromAnotherIngkaCompany={isLeasedFromAnotherIngkaCompany}
          currency={currency}
          currencyRate={currencyRate}
          isEdit={isEdit}
        />
      );
    case ESTABLISHMENT_TYPE.IMPROVE:
      return (
        <ImproveSiteForm
          countries={countries}
          onCountryChange={onCountryChange}
          onBUChange={onBUChange}
          BUList={BuList}
          transactionType={transactionType}
          isLeasedFromAnotherIngkaCompany={isLeasedFromAnotherIngkaCompany}
          currency={currency}
          currencyRate={currencyRate}
          isEdit={isEdit}
        />
      );
    case ESTABLISHMENT_TYPE.RELOCATION:
      return (
        <RelocationSiteForm
          countries={countries}
          BuList={BuList}
          onCountryChange={onCountryChange}
          onBUChange={onBUChange}
          transactionType={transactionType}
          isLeasedFromAnotherIngkaCompany={isLeasedFromAnotherIngkaCompany}
          currency={currency}
          currencyRate={currencyRate}
          isEdit={isEdit}
        />
      );
    case ESTABLISHMENT_TYPE.FORMAT_CHANGE:
      return (
        <FormatChangeSiteForm
          countries={countries}
          onCountryChange={onCountryChange}
          onBUChange={onBUChange}
          BUList={BuList}
          transactionType={transactionType}
          isLeasedFromAnotherIngkaCompany={isLeasedFromAnotherIngkaCompany}
          currency={currency}
          currencyRate={currencyRate}
          isEdit={isEdit}
        />
      );
    case ESTABLISHMENT_TYPE.CLOSE:
      return (
        <CloseSiteForm
          countries={countries}
          BuList={BuList}
          onCountryChange={onCountryChange}
          onBUChange={onBUChange}
          isEdit={isEdit}
        />
      );
  }
};

export default SiteTab;
